export default __webpack_public_path__ + "static/media/01_photo.8872dc5e.jpg";